import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon, Label } from 'semantic-ui-react';
import _ from 'lodash';
import uuidV4 from 'uuid/v4';

import { StyledLabelsContainer, StyledTitleContainer } from 'components/Layout';
import NoteService from 'shared/services/api/notepratica';

import NewNote from './newNote';
import Notes from './notes';

export class Note extends Component {
  static propTypes = {
    praticaId: PropTypes.string,
    anagrafica: PropTypes.bool,
    notes: PropTypes.array,
    onChange: PropTypes.func,
    title: PropTypes.string,
  };

  state = {
    activeIndex: null,
    nota: '',
    notes: [],
    newNoteVisible: false,
  }

  componentDidMount() {
    this.getNotes();
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.anagrafica && nextProps.notes && this.props.notes) {
      if (nextProps.notes.length !== this.props.notes.length) {
        this.setState({ notes: nextProps.notes });
      }
    }
  };

  getNotes = () => {
    if (this.props.anagrafica) { // Se la nota viene da una array passato dall'anagrafica popolo immediatamente
      this.setState({
        notes: this.props.notes || [],
        newNoteVisible: !_.isEmpty(this.props.notes),
      });
    } else { // Se le note sono di pratica bisogna fetchare dal server
      NoteService.getByPratica(this.props.praticaId)
        .then((res) => {
          this.setState({
            notes: _.get(res, '_embedded.nota_pratica') ?
                  res._embedded.nota_pratica : [],
            newNoteVisible: !(_.get(res, '_embedded.nota_pratica["length"]')),
          });
        });
    }
  }

  addNote = (note) => { // Metodo per aggiungere la nota all'array di note esistenti
    const notes = _.cloneDeep(this.props.notes);
    notes.unshift(note);
    return notes;
  }

  reloadNotes = () => {
    this.getNotes();
    this.reset();
  };

  submitNota = () => {
    const payload = {
      descrizione: this.state.nota,
    };

    if (this.props.anagrafica) {
      payload.id = uuidV4();
      this.props.onChange('note', this.addNote(payload));
      this.reset();
    } else {
      payload.pratica = this.props.praticaId || '';
      NoteService.create(payload).then(this.reloadNotes);
    }
  };

  deleteNote = (id) => {
    if (this.props.anagrafica) {
      const filteredNotes = _.filter(this.props.notes, (note) => note.id !== id);
      this.props.onChange('note', filteredNotes);
      this.reset();
    } else {
      NoteService.del(id).then(this.reloadNotes);
    }
  };

  reset = () => {
    this.setState({ nota: '', newNoteVisible: false });
  }

  handleNotaChange = (nota) => this.setState({ nota });

  handleClick = (e, titleProps) => {
    const { index, toggle } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index && toggle !== false ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handlePlusClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ newNoteVisible: true });
    this.handleClick(null, { index: 0, toggle: false });
    // console.log('EVENT', e);
  };

  render() {
    const { activeIndex } = this.state;
    return (
      <Accordion fluid styled style={{ marginBottom: 15 }}>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          style={{ position: 'relative', paddingLeft: 25 }}
          onClick={this.handleClick}
        >
          <StyledLabelsContainer>
            <Label
              style={{
                border: '1px solid #2185d0',
                background: '#fff',
                color: '#2185d0',
              }}
              circular
              onClick={(/* e*/) => {
                // e.preventDefault();
                // e.stopPropagation();
                // console.log("EVENT", e);
              }}
            >
              {this.state.notes.filter((n) => !n.parent).length}
            </Label>
            <Label
              circular
              style={{
                width: 25,
                border: '1px solid #2185d0',
                background: '#2185d0',
                color: '#fff',
              }}
              onClick={this.handlePlusClick}
            >
              <Icon name="plus" style={{ marginLeft: 1 }} />
            </Label>
          </StyledLabelsContainer>
          <Icon name="dropdown" />
          <StyledTitleContainer>
            { !this.props.title ? `Note di ${this.props.anagrafica ? 'anagrafica' : 'pratica'}` : this.props.title }
          </StyledTitleContainer>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          { this.state.newNoteVisible &&
            <NewNote anagrafica={this.props.anagrafica} submit={this.submitNota} reset={this.reset} nota={this.state.nota} onChange={this.handleNotaChange} />
          }
          <Notes notes={this.state.notes} update={this.getNotes} delete={this.deleteNote} />
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default Note;



// WEBPACK FOOTER //
// ./app/components/Note/index.js